import * as React from 'react'

const IconSolidPin = () => (
	<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'>
		<path
			fill='currentColor'
			fillRule='evenodd'
			d='M12.959 21.046C16.615 17.421 20 14.064 20 10a8 8 0 1 0-16 0c0 4.064 3.385 7.42 7.04 11.046q.48.474.96.954.48-.48.959-.954M12 14a4 4 0 1 0 0-8 4 4 0 0 0 0 8'
			clipRule='evenodd'
		/>
		<path
			fill='currentColor'
			d='m12.96 21.046-.353-.355-.001.002zm-.001 0 .352.355.002-.001zm-1.918 0-.352.355.004.004zm0 0 .352-.355-.004-.003zM12 22l-.354.354a.5.5 0 0 0 .708 0zm.96-.954-.354-.354.353.354.354.354zM20 10h-.5c0 1.886-.784 3.64-2.054 5.395-1.275 1.76-3.003 3.476-4.839 5.296l.352.355.352.355c1.82-1.805 3.613-3.58 4.945-5.42C19.59 14.136 20.5 12.178 20.5 10zm-8-8v.5a7.5 7.5 0 0 1 7.5 7.5h1A8.5 8.5 0 0 0 12 1.5zm-8 8h.5A7.5 7.5 0 0 1 12 2.5v-1A8.5 8.5 0 0 0 3.5 10zm7.04 11.046.353-.355c-1.836-1.82-3.564-3.536-4.839-5.296C5.284 13.639 4.5 11.886 4.5 10h-1c0 2.178.909 4.136 2.244 5.98 1.332 1.84 3.124 3.616 4.945 5.421zm0 0 .35-.358h-.001zl-.348.359zM12 22l.354-.354-.961-.955-.352.355-.352.355q.478.474.957.953zm.959-.954-.352-.355q-.478.474-.96.955L12 22l.354.354q.48-.48.957-.953zM16 10h-.5a3.5 3.5 0 0 1-3.5 3.5v1a4.5 4.5 0 0 0 4.5-4.5zm-4-4v.5a3.5 3.5 0 0 1 3.5 3.5h1A4.5 4.5 0 0 0 12 5.5zm-4 4h.5A3.5 3.5 0 0 1 12 6.5v-1A4.5 4.5 0 0 0 7.5 10zm4 4v-.5A3.5 3.5 0 0 1 8.5 10h-1a4.5 4.5 0 0 0 4.5 4.5z'
		/>
	</svg>
)

export default IconSolidPin
